import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useEta, formatEta } from '../hooks/useJobs';
/** Muestra la duración estimada de un job ANTES de lanzarlo, basada en la
 *  mediana de los jobs anteriores del mismo kind. Si no hay histórico
 *  todavía, lo dice explícitamente en vez de mostrar un número falso. */
export default function EtaHint({ kind }) {
    const { t } = useTranslation();
    const { eta, loading } = useEta(kind);
    if (loading)
        return null;
    return (_jsx("p", { className: "eta-hint muted", children: eta === null
            ? t('eta.noHistory')
            : t('eta.estimate', { time: formatEta(eta) }) }));
}
